<template>
    <div>
        <div class="backpack-modal modal fade" tabindex="-1" :class="{'backpack-empty-modal': !studentsWithPrices.length }" role="dialog" aria-labelledby="backpakModal" aria-hidden="true">
            <div class="modal-dialog modal-pdv">
                <div class="modal-content">
                    <template v-if="studentsWithPrices.length">
                        <div class="modal-title">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="backpack-title">
                                <img src="/images/iconos/Flecha-derecha.svg" alt="">
                                <h4 v-if="studentsWithPrices.length > 1">Tu mochila de compras ({{studentsWithPrices.length}} programas)</h4>

                                <h4 v-if="studentsWithPrices.length === 1">Tu mochila de compras</h4>
                            </div>

                            <div class="message-info-box message-info-box--alert">
                                <img src="/images/iconos/icon-alert-circle-red.svg" alt="">
                                <p>Los cupos de los cursos en tu Mochila de Compras pueden agotarse rápidamente.
                                    <br>
                                    Cómpralos pronto para que no pierdas los horarios que elegiste</p>
                            </div>
                        </div>

                        <div class="main-content">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="programs-list-selected">
                                        <div v-if="studentsWithPrices.length">
                                             <div v-for="(student, index) in studentsWithPrices" :key="index" class="program-selected">
                                                <div class="plan-selected-title" :class="{ 'plan-selected-title-red' :  student.program.name === 'Tradicional PSU 4° Medio', 'plan-selected-title-purple' :  student.program.name === 'Academia PSU Egresados'}">
                                                    <span>Programa P.T</span>
                                                    <h2>{{ student.program.name }}</h2>
                                                </div>

                                                <div class="price">
                                                    <p>Monto programa {{index + 1}}</p>
                                                    <span v-if="student.prices">{{ student.prices.precioTotal | moneyFormatter }}</span>
                                                </div>

                                                <p>Programa asociado al estudiante: <strong>{{ student.name }} {{student.fatherLastName}}</strong></p>

                                                <div class="delete-program">
                                                    <a href="#" @click.prevent="removeStudent(student.id)" class="underline-link underline-link--secondary"><img src="/images/iconos/icon-delete.svg" alt=""> ELIMINAR PROGRAMA</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="abstract-check-in-info-cont">
                                        <abstract-check-in-info @buttonClicked="saveOrderData" :total="total"></abstract-check-in-info>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>


                    <!-- backpack Empty -->
                    <template v-else>
                        <div class="modal-title">
                            <router-link :to="{name: 'Landing'}" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </router-link>

                            <div class="backpack-title">
                                <img src="/images/iconos/Flecha-derecha.svg" alt="">
                                <h4>Tu mochila de compras</h4>
                            </div>
                        </div>

                        <div class="main-content">
                            <div class="main-content-empty-backpack">
                                <img src="/images/iconos/mochila-vacia.png" alt="">
                                <div class="ml-4">
                                    <h3>TU MOCHILA DE COMPRAS ESTÁ VACÍA</h3>
                                    <p>Eliminaste los programas que habías seleccionado</p>

                                    <div class="row">
                                        <div class="col-8">
                                            <router-link :to="{name: 'Landing'}" data-dismiss="modal" class="btn-pdv-primary w-100 text-center">ELIGE TU PROGRAMA</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

    import AbstractCheckInInfo from "@/components/AbstractCheckInInfo";
    export default {
        data(){
          return {
              total: null
          }
        },

        computed:{
            studentsWithPrices(){
                return this.$store.state.studentsWithPrices
            },
            students(){
                return this.$store.state.students
            }

        },

        components: {
            AbstractCheckInInfo
        },

        methods:{

            removeStudent(studentId){
                this.$store.dispatch('removeStudent', studentId)
                    .then(()=>{
                        this.$store.dispatch('setStudentsWithPrices');
                        if(this.studentsWithPrices.length){
                            this.setTotal()
                        }else{
                            this.total = 0;
                            this.$store.dispatch('hideBackpack');
                        }
                    });

            },

            saveOrderData() {
                let fullOrderStudentsData = this.students.map(student => {
                    return {
                        locationId: student.selectedLocation.id,
                        programId: student.program.id,
                        coursesIds: student.selectedCourses.map(course => course.courseId),
                        studentId: student.id
                    }
                });

                this.$store.dispatch('addInfoToFullOrder', { orderDetails: fullOrderStudentsData })
                    .then(() => {
                        this.goToNextStep();
                    })
            },

            setTotal(){
                this.total = this.studentsWithPrices.map(student => student.prices.precioTotal).reduce((previousValue, currentValue) => previousValue + currentValue);
            },

            goToNextStep(){
                this.$router.push({name: 'Step4'});
            }
        },

        mounted() {

            if(this.studentsWithPrices.length){
                this.setTotal()
            }
        }


    }
</script>

<style scoped lang="scss">
    .backpack-modal{
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv{
            max-width: 951px;
            @include media-breakpoint-down(sm){
                margin: 65px 0 0;
            }
            .modal-content{
                padding: 35px 40px;
                border-radius: 1px;
                border: 1px solid #000;
                box-shadow: 0 0 12px 3px #00000038;
                .modal-title{
                    button.close{
                        position: absolute;
                        right: 15px;
                        top: 15px;
                        opacity: 1;
                        span{
                            font-size: 30px;
                            color: $brown-light;
                        }
                    }
                    .backpack-title{
                        display: flex;
                        align-items: center;
                        margin-bottom: 11px;
                        img{
                            margin-right: 5px;
                        }
                        h4{
                            font-size: 18px;
                            line-height: 21px;
                            margin-bottom: 0;
                            @include alternative-regular;
                        }

                    }
                    .message-info-box{
                        align-items: center;
                        padding: 12px 16px;
                        img{
                            margin-right: 15px;
                        }
                        P{
                            margin-bottom: 0;
                        }
                        @include media-breakpoint-down(sm){
                            margin: 0 -40px 0;
                        }
                    }
                }
                .main-content{
                    .programs-list-selected{
                        .program-selected{
                            padding: 25px 0;
                            .sub-title{
                                color: #fff;
                                font-size: 13.6px;
                                letter-spacing: 3.4px;
                                line-height: 13px;
                                padding: 2px 5px;
                            }
                            h3{
                                font-size: 18.7px;
                                line-height: 30px;
                                font-weight: 900;
                            }
                            .price{
                                display: flex;
                                align-items: center;
                                p{
                                    margin-bottom: 0;
                                    margin-right: 10px;
                                    font-size: 16px;
                                    line-height: 18px;
                                    @include alternative-medium-regular;
                                }
                                span{
                                    font-size: 20px;
                                    @include alternative-bold;
                                    line-height: 23px;
                                }
                            }

                            p{
                                font-size: 14px;
                                @include alternative-light-regular;
                            }
                            .delete-program{
                                display: flex;
                                align-items: center;
                                img{
                                    margin-right: 5px;
                                }
                            }
                        }
                    }

                    .abstract-check-in-info-cont{
                        position: relative;
                        margin: 25px 0;
                    }

                    @include media-breakpoint-down(sm){
                        padding-bottom: 160px;
                    }
                }
            }

            .plan-selected-title{
                span{
                    letter-spacing: 3.4px;
                    font-size: 13.6px;
                    padding: 3px 6px;
                    color: gray;
                    @include media-breakpoint-down(sm){
                        font-size: 10px;
                        padding: 2px 5px;
                    }
                }
                h2{
                    font-size: 18.7px;
                    line-height: 30px;
                    margin-bottom: 0;
                    text-transform: uppercase;
                    @include font-black-regular;
                    color: $red-2-light;
                    @include media-breakpoint-down(sm){
                        font-size: 12.5px;
                        line-height: 14px;

                    }
                }
                &.plan-selected-title-red{
                    span{
                        background: $red-light;
                    }

                    h2{
                        color: $red-2-light;
                    }

                }

                &.plan-selected-title-purple{
                    span{
                        background: $purple-light;
                    }

                    h2{
                        color: $purple;
                    }

                }

            }

        }
    }

    .backpack-empty-modal{
        opacity: 1 !important;
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv{
            max-width: 951px;
            transform: unset;
            @include media-breakpoint-down(sm){
                margin: 65px 0 0;
            }
            .modal-content{
                padding: 35px 40px;
                border-radius: 1px;
                border: 1px solid #000;
                box-shadow: 0 0 12px 3px #00000038;
                height: 566px;
                .modal-title{
                        .close{
                        position: absolute;
                        right: 15px;
                        top: 15px;
                        opacity: 1;
                        span{
                            font-size: 30px;
                            color: $brown-light;
                        }
                    }
                    .backpack-title{
                        display: flex;
                        align-items: center;
                        margin-bottom: 11px;
                        img{
                            margin-right: 5px;
                        }
                        h4{
                            font-size: 18px;
                            line-height: 21px;
                            margin-bottom: 0;
                            @include alternative-regular;
                        }

                    }
                }
                .main-content{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    .main-content-empty-backpack{
                        display: inline-flex;
                        align-items: center;
                        width: 70%;
                        img{
                            width: 183px;
                        }
                        h3{
                            font-size: 20px;
                            line-height: 23px;
                            @include alternative-bold;
                        }
                        p{
                            font-size: 18px;
                            line-height: 26px;
                            @include alternative-regular;
                            margin-bottom: 19px;
                        }
                    }
                }
            }

        }
    }

</style>